import React, { useEffect, useState } from "react";
import axios from "../../../../utils/axios";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import PoPdfGenerator from "./PoPdfGenerator";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactHtmlParser from "react-html-parser";


const PurchaseOrders = ({ rfqId, poData, poLoading, poError }) => {
  const navigate = useNavigate();
  
  const [isPDFViewerOpen, setIsPDFViewerOpen] = useState(false);
  const [selectedPo, setSelectedPo] = useState(null);

  const auth = useSelector((state) => state.auth);
  const user = auth?.user;
  const companyStampSign = user?.userEntity?.companyStampSign || "";

  const handleOpenPDFViewer = (po) => {
    setSelectedPo(po);
    setIsPDFViewerOpen(true);
  };

  const handleDownloadPO = (po) => {
    const poPdf = <PoPdfGenerator poData={po} companyStampSign={companyStampSign} />;
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(new Blob([poPdf]));
    downloadLink.download = `PO_${po.poId}.pdf`;
    downloadLink.click();
  };
  const handleClosePDFViewer = () => {
    setIsPDFViewerOpen(false);
    setSelectedPo(null);
  };

  const handleEditPO = (po) => {
    navigate(`/create-po?rfqId=${rfqId}&edit=true`, {
      state: { poDataToUpdate: po },
    });
  };

  

  if (poLoading) {
    // Loader while data is being fetched
    return (
      <div className="flex justify-center items-center h-[100vh]">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (poError) {
    // Display error message
    return (
      <div
        style={{ height: "calc(100vh - 67px)" }}
        className="flex justify-center items-center w-full"
      >
        <div className="flex flex-col items-center justify-center">
          <img
            src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Search_image.png"
            alt="Search Image"
            className="h-[116px] w-[122px] mb-6"
          />
          <p className="text-md font-bold text-[#3C3C3C]">
            No Purchase Orders Created
          </p>
        </div>
      </div>
    );
  }

  if (poData.length === 0) {
    // Show message if no PO is found
    return (
      <div
        style={{ height: "calc(100vh - 67px)" }}
        className="flex justify-center items-center  w-full"
      >
        <div className="flex flex-col items-center justify-center">
          <img
            src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Search_image.png"
            alt="Search Image"
            className="h-[116px] w-[122px] mb-6"
          />
          <p className="text-md font-bold text-[#3C3C3C]">
            No Purchase Orders Created
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <table className="w-full border border-collapse text-xs">
        <thead>
          <tr className="bg-[#F5F5F3] text-center text-xs text-[#727269]">
            <th className="border font-medium p-2">Sr #</th>
            <th className="border font-medium p-2">Create Date</th>
            <th className="border font-medium p-2">PO Number</th>
            <th className="border font-medium p-2">Vendor Name</th>
            <th className="border font-medium p-2">Total Basic Amount</th>
            <th className="border font-medium p-2">GST Amount</th>
            <th className="border font-medium p-2">Total Amount</th>
            <th className="border font-medium p-2">Prepared By</th>
            <th className="border font-medium p-2">Updated By</th>
            <th className="border font-medium p-2">Actions</th>
            {/* <th className="border font-medium p-2">Download PO</th> */}
          </tr>
        </thead>
        <tbody>
          {poData.map((po, index) => (
            <tr key={po.poId} className="bg-white text-left">
              <td className="border hover:bg-[#ecece3] p-2 text-right">
                {index + 1}
              </td>
              <td className="border hover:bg-[#ecece3] p-2 text-center">
                {po.poDate}
              </td>
              <td className="border hover:bg-[#ecece3] p-2 text-right">
                {po.poId}
              </td>
              <td className="border hover:bg-[#ecece3] p-2">
                {ReactHtmlParser(po.supplierName)}
              </td>
              <td className="border hover:bg-[#ecece3] p-2 text-right">
                Rs. {po.totalExclGst.toLocaleString("en-IN")}
              </td>
              <td className="border hover:bg-[#ecece3] p-2 text-right">
                Rs.{" "}
                {(po.totalInclGst - po.totalExclGst).toLocaleString("en-IN")}
              </td>
              <td className="border hover:bg-[#ecece3] p-2 text-right">
                Rs. {po.totalInclGst.toLocaleString("en-IN")}
              </td>
              <td className="border hover:bg-[#ecece3] p-2">
                {po?.preparedBy}
              </td>
              <td className="border hover:bg-[#ecece3] p-2">{po?.updatedBy}</td>
              <td className="border">
                <div className="space-x-4 p-2 flex justify-evenly">
                  {/* View & Download PO */}
                  <div className="relative group">
                    <button
                      type="button"
                      onClick={() => handleOpenPDFViewer(po)}
                    >
                      <img
                        src="https://storagereponeevaydevcdn.blob.core.windows.net/business/purchase-order_11000544.png"
                        alt=""
                        className="h-4 w-4"
                      />
                    </button>
                    <span className="absolute bottom-full w-[130px] left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none">
                      View & Download PO
                    </span>
                  </div>

                  {/* Edit PO */}
                  <div className="relative group">
                    <button type="button" onClick={() => handleEditPO(po)}>
                      <img
                        src="https://storagereponeevaydevcdn.blob.core.windows.net/business/pencil_gray_create_rfq.svg"
                        alt=""
                        className="h-4 w-4"
                      />
                    </button>
                    <span className="absolute bottom-full w-[58px] left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none">
                      Edit PO
                    </span>
                  </div>

                  {/* Download PO */}
                  <div className="relative group">
                    {/* PDFDownloadLink wrapping the button */}
                    <PDFDownloadLink
                      document={<PoPdfGenerator poData={po}/>}
                      fileName={`PO_${po.poId}.pdf`}
                    >
                      {({ loading }) => (
                        <button
                          type="button"
                          disabled={loading} // Disable the button while PDF is loading
                          className="flex items-center space-x-2"
                        >
                          <img
                            src="https://storagereponeevaydevcdn.blob.core.windows.net/business/download_solid.svg"
                            alt="Download Icon"
                            className="h-4 w-4"
                          />
                          <span className="absolute bottom-full w-[90px] left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none">
                            Download PO
                          </span>
                        </button>
                      )}
                    </PDFDownloadLink>
                  </div>

                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {isPDFViewerOpen && selectedPo && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-[75%] h-[98%] flex flex-col z-999">
            <div className="flex justify-between items-center p-2 border-b">
              <h2 className="text-base font-bold">
                PO PDF Preview - {selectedPo?.poId}
              </h2>
              <button
                onClick={handleClosePDFViewer}
                className="text-red-600 hover:text-red-800 font-semibold"
              >
                Close
              </button>
            </div>
            <div className="flex-grow overflow-auto z-70 relative">
              <PDFViewer width="100%" height="100%" className="h-full w-full">
                <PoPdfGenerator
                  poData={selectedPo}
                  companyStampSign={companyStampSign}
                />
              </PDFViewer>
            </div>
            <div className="p-2 border-t">
              <PDFDownloadLink
                key={selectedPo?.poId} // Ensure the component re-renders
                document={
                  <PoPdfGenerator
                    poData={selectedPo}
                    companyStampSign={companyStampSign}
                  />
                }
                fileName={`PO_${selectedPo?.poId || "Export"}.pdf`}
              >
                {({ loading, url, blob }) =>
                  loading ? (
                    <button className="bg-black text-white px-4 py-2 rounded">
                      Preparing PDF...
                    </button>
                  ) : (
                    <a
                      href={url}
                      download={`PO_${selectedPo?.poId || "Export"}.pdf`}
                      className="bg-black text-white px-4 py-1 rounded inline-block"
                    >
                      Download PDF
                    </a>
                  )
                }
              </PDFDownloadLink>
              <button
                onClick={() => handleEditPO(selectedPo)}
                className="border border-solid px-4 py-1 rounded ml-2"
              >
                Edit PO
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseOrders;
